import React from "react";
import { Col, Form, Input, Modal, Row, Select, theme } from "antd";
import { SUCCESS_COLOR } from "../../constants/color";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_CHEMICAL } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import { QUALITY_CHEMICAL_TYPE, QUALITY_CHEMICAL_TYPE_OPTIONS } from "../../constants/string";

export default function AddPureChemicalModal(props) {

  const { open, onClose, target, onUpdate} = props;
  const [loading, setLoading] = React.useState(false);
  const [ errorMessages, setErrorMessages ] = React.useState(null);
  const [form] = Form.useForm();
  const isCreate = target === 'add'

  const {
    token: { colorWarning },
  } = theme.useToken();

  const handleOk = async() => {
    setLoading(true)
    setErrorMessages(null)
    try {
      const data = await form.validateFields()
      const formattedData = prepareData(data);
      if(isCreate){
        await POST(URL_CHEMICAL.QUALITY_CHEMICAL, formattedData)
      } else {
        await PATCH(`${URL_CHEMICAL.QUALITY_CHEMICAL}${target.id}/`, formattedData)
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  const prepareData = (data) => {
    return {
      ...data,
      tank : data.fill ? data.fill.includes(QUALITY_CHEMICAL_TYPE.TANK) : false,
      pond : data.fill ? data.fill.includes(QUALITY_CHEMICAL_TYPE.POND) : false
    }
  }

  React.useEffect(() => {
    if(open){
      setErrorMessages(null)
      if(isCreate){
        form.resetFields();
      } else {
        const arrFill = [];
        if(target.tank)
          arrFill.push(QUALITY_CHEMICAL_TYPE.TANK)
        if(target.pond)
          arrFill.push(QUALITY_CHEMICAL_TYPE.POND)
        form.setFieldsValue({...target,
          fill : arrFill
        })
      }
    } else {
      form.resetFields();
    }
  },[open])

	return(
    <Modal
      open={open}
      onCancel={onClose}
      okText={isCreate ? "ตกลง" : "แก้ไข"}
      okButtonProps={{ style: { backgroundColor : isCreate ? SUCCESS_COLOR : colorWarning}, loading: loading }}
      cancelText={"ไม่"}
      cancelButtonProps={{ loading: loading }}
      title={isCreate ? "เพิ่มสารเคมีคุณภาพ": "แก้ไขสารเคมีคุณภาพ"}
      width={500}
      onOk={handleOk}
    >
      <ErrorMessages message={errorMessages}/>
      <Form
        form={form}
        layout={'vertical'}
      >
        <Row>
          <Col span={24}>
            <Form.Item 
              label={'ชื่อสารเคมี'} 
              style={{marginRight : 10}}
              name={"name"}
              rules={[{ required : true, message: "กรุณาใส่ชื่อสารเคมี!"  }]}
            >
              <Input style={{ width : '100%' }} placeholder={'ชื่อสารเคมี'} autoComplete="off"/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item 
              label={'งานเติมสาร'} 
              style={{marginRight : 10}}
              name={"fill"}
            >
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder="เลือกงานเติมสาร"
              options={QUALITY_CHEMICAL_TYPE_OPTIONS}
            />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
)
}